import { render, staticRenderFns } from "./WizardStep.vue?vue&type=template&id=b868968a&scoped=true&"
import script from "./WizardStep.vue?vue&type=script&lang=ts&"
export * from "./WizardStep.vue?vue&type=script&lang=ts&"
import style0 from "./WizardStep.vue?vue&type=style&index=0&id=b868968a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b868968a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b868968a')) {
      api.createRecord('b868968a', component.options)
    } else {
      api.reload('b868968a', component.options)
    }
    module.hot.accept("./WizardStep.vue?vue&type=template&id=b868968a&scoped=true&", function () {
      api.rerender('b868968a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/WizardStep.vue"
export default component.exports